import { render, staticRenderFns } from "./popupIFrame.vue?vue&type=template&id=f95354ce&scoped=true&lang=true&"
import script from "./popupIFrame.vue?vue&type=script&lang=js&"
export * from "./popupIFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95354ce",
  null
  
)

export default component.exports